// Generated by CoffeeScript 2.7.0
var TagsListContainer;

export default TagsListContainer = Vue.extend({
  props: {
    selectedTagsGroupName: {
      type: String
    },
    extendClass: {
      type: String
    }
  },
  template: `<div class="tags-list-container" :class="extendClass">
  <slot name="title">
    <div class="list-title">{{ selectedTagsGroupName }}</div>
  </slot>
  <div class="list-content">
    <slot name="content"></slot>
  </div>
</div>`
});
